// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.InstitutionPublications_institution-publications__AKGcJ {
  display: flex;
  flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/Explore/Pages/InstitutionDetail/Components/InstitutionPublications/InstitutionPublications.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;AACF","sourcesContent":[".institution-publications {\n  display: flex;\n  flex-direction: column;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"institution-publications": `InstitutionPublications_institution-publications__AKGcJ`
};
export default ___CSS_LOADER_EXPORT___;
